import { initReactI18next } from 'react-i18next';

import { enTranslation } from './locale/en';
import { uaTranslation } from './locale/ua';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const defaultNS = 'translation';
export const resources = { en: enTranslation, ua: uaTranslation };

const language = localStorage.getItem('I18N_LANGUAGE');

if (!language) {
  localStorage.setItem('I18N_LANGUAGE', 'en');
}

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('I18N_LANGUAGE') || 'en',
    interpolation: { escapeValue: false },
    defaultNS,
  });

export default i18n;
